import { useState } from 'react';

export default function useSelectedSystems(defaultSystems) {
  const [selectedSystems, setSelectedSystems] = useState(defaultSystems);

  const handleSelectedSystemsChange = (systems) => {
    if (systems) {
      setSelectedSystems(systems);
    }
  };
  return [selectedSystems, handleSelectedSystemsChange];
}
